module.exports = __webpack_public_path__ + "img/btn_prostate_on.a5c6872d.svg";